export class ChangePasswordData {
  oldPassword = '';
  newPassword = '';
  confirmPassword = '';
}
